import React from "react";

const Logo = props => {
  const fill = props.fill || "#000";

  return (
    <svg width={253} height={97} fill="none" {...props} viewBox="0 0 253 97">
      <mask
        id="logo_svg__a"
        maskUnits="userSpaceOnUse"
        x={-0.415}
        y={15.526}
        width={81}
        height={81}
        fill="#000"
      >
        <path fill="#fff" d="M-.415 15.526h81v81h-81z" />
        <path d="M63.118 79.059c-12.476 12.475-32.702 12.475-45.177 0-12.475-12.475-12.475-32.701 0-45.177 12.475-12.475 32.701-12.475 45.177 0 12.475 12.476 12.475 32.702 0 45.177z" />
      </mask>
      <path
        d="M57.46 73.402c-9.35 9.35-24.511 9.35-33.862 0L12.284 84.716c15.6 15.599 40.891 15.599 56.49 0L57.462 73.402zm-33.862 0c-9.351-9.351-9.351-24.512 0-33.863L12.284 28.225c-15.6 15.6-15.6 40.891 0 56.49l11.314-11.313zm0-33.863c9.35-9.35 24.512-9.35 33.863 0l11.314-11.314c-15.6-15.599-40.891-15.599-56.49 0L23.597 39.54zm33.863 0c9.35 9.351 9.35 24.512 0 33.863l11.314 11.314c15.599-15.6 15.599-40.891 0-56.49L57.46 39.538z"
        fill={fill}
        mask="url(#logo_svg__a)"
      />
      <path
        d="M23.588 39.53c-9.356 9.356-9.356 24.525 0 33.882 9.357 9.356 24.526 9.356 33.883 0L23.588 39.529zM6.647 0L97 90.353 91.353 96 1 5.647zM121.615 56.89H106.63L103.57 64h-7.065l14.715-32.04h5.67L131.605 64h-6.93l-3.06-7.11zm-2.295-5.355l-5.175-12.015-5.175 12.015h10.35zm46.836-19.575V64h-6.21V46.495L152.566 64h-4.545l-7.425-17.28V64h-6.165V31.96h5.58l10.35 23.625 10.26-23.625h5.535zm6.461 0h14.535c3.54 0 6.285.855 8.235 2.565 1.98 1.71 2.97 4.035 2.97 6.975 0 2.91-.99 5.235-2.97 6.975-1.98 1.71-4.725 2.565-8.235 2.565h-7.515V64h-7.02V31.96zm13.635 13.725c3.66 0 5.49-1.38 5.49-4.14 0-2.79-1.83-4.185-5.49-4.185h-6.615v8.325h6.615zm16.731-13.725h7.02v26.325h14.31V64h-21.33V31.96zm25.62 0h22.095v5.445h-15.255v7.56h14.31v5.49h-14.31v8.1h15.255V64h-22.095V31.96z"
        fill={fill}
      />
    </svg>
  );
};

export default Logo;
